"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AboutUsPage = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var our_team_1 = require("./our_team");
var section_swapper_1 = require("../../../components/section_swapper");
var shop_front_png_1 = __importDefault(require("../../../assets/become_franchise/shop_front.png"));
var over_view_inside_png_1 = __importDefault(require("../../../assets/about_us/over_view_inside.png"));
var smiling_counter_png_1 = __importDefault(require("../../../assets/about_us/smiling_counter.png"));
var AboutUsPage = function () {
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-24" },
            react_1.default.createElement(section_swapper_1.SectionSwapperComponent, { imageSide: "right", image: over_view_inside_png_1.default, smallTitle: "OUR STORY", bigTitle: "Who we are.", 
                // buttonText="Learn More"
                description: "The Local Choice Franchise is an aligned, like-minded group of independent pharmacists, working together to help people get, feel and live better. Local Choice Pharmacies take the time to offer personal care to each patient and to make a positive difference to their daily lives.", content: [
                    "Our pharmacists are committed to open communication and the nurturing of relationships to the benefit of the local community's health.",
                    "We are a supply chain partner of Dis-Chem, affording customers a larger variety of vitamins, supplements, baby, personal care and first aid.",
                    "The Local Choice' vision and mission is to provide a wide range of primary health care services in a convenient, cost-effective way.",
                ] }),
            react_1.default.createElement(section_swapper_1.SectionSwapperComponent, { imageSide: "left", image: shop_front_png_1.default, smallTitle: "HISTORY", bigTitle: "Where it all began.", 
                // buttonText="Learn More"
                description: "The Local Choice Pharmacy Group is built on a foundation of professional expertise and personal service, The Local Choice Pharmacy Group has been meeting customers' healthcare needs since 2011.", content: [
                    "With humble beginnings in Delmas in October 2011, we have grown into an organization of over 240 stores throughout South Africa, becoming an indelible part of their communities. Yet despite our stellar growth, we haven't forgotten our origins and deeply care for our local communities and their health.",
                ] }),
            react_1.default.createElement(section_swapper_1.SectionSwapperComponent, { imageSide: "right", image: smiling_counter_png_1.default, smallTitle: "THE LOCAL CHOICE", bigTitle: "Our values.", 
                // buttonText="Learn More"
                description: "We greatly pride ourselves in the following:", content: [
                    {
                        title: "Trust",
                        description: "Patients already have a long continued relationship with our Pharmacists and greatly value The Local Choice Pharmacists' advice. We believe that your community pharmacist has been a trusted source of family healthcare and we strive to offer this continued service to all our Locals.",
                    },
                    {
                        title: "Access",
                        description: "With over 240 stores nationwide, quality health care and advice are available practically right on your doorstep.",
                    },
                    {
                        title: "Skills and services",
                        description: "Our Pharmacists are qualified and experienced health professionals, offering advice and support in a range of health conditions and the treatment thereof.",
                    },
                    {
                        title: "Cost",
                        description: "We understand that South Africans want value for money, and easy access to quality healthcare is important.",
                    },
                    {
                        title: "Health care services",
                        description: "All The Local Choice pharmacies provide basic health care services. Some in-store clinics provide wellness screenings, health screenings, disease management and virtual care.",
                    },
                ] }),
            react_1.default.createElement(our_team_1.OurTeamComponent, null))));
};
exports.AboutUsPage = AboutUsPage;
